import Vue from 'vue'
import Vuex from 'vuex'
import permission from './permission'
import creative from '@/store/creative'
import config from '@pt/store/config'
import user from './user/index'
import pt from './pt/index'
import getters from './getters'
import record from './record'
import assets from './assets'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    config,
    user,
    permission,
    pt,
    creative,
    record,
    assets,
  },
  getters,
})

export default store
